// Arabic (RTL) pages: keep every price as "19 JOD" — the RTL layout flips a bare "19 JOD" into "JOD 19".
// Wraps each amount in <bdi dir="ltr"> wherever it appears (theme, cart, app widgets), now and as content changes.
(() => {
  if (document.documentElement.dir !== 'rtl') return;
  const RE = /(\d[\d.,]*\s?JOD)/;
  const skip = (el) => !el || el.closest('bdi, script, style, textarea, input, select, option');
  const wrap = (root) => {
    if (!root || root.nodeType !== 1 || skip(root) && root.tagName !== 'BODY') { if (root && root.nodeType === 1 && root.closest('bdi')) return; }
    const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (RE.test(n.nodeValue) && !skip(n.parentElement) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT)
    });
    const nodes = [];
    for (let n = w.nextNode(); n; n = w.nextNode()) nodes.push(n);
    nodes.forEach((n) => {
      const parts = n.nodeValue.split(RE);
      const frag = document.createDocumentFragment();
      parts.forEach((p, i) => {
        if (i % 2) { const b = document.createElement('bdi'); b.dir = 'ltr'; b.textContent = p; frag.appendChild(b); }
        else if (p) frag.appendChild(document.createTextNode(p));
      });
      n.replaceWith(frag);
    });
  };
  wrap(document.body);
  new MutationObserver((ms) => {
    ms.forEach((m) => {
      if (m.type === 'characterData') { if (m.target.parentElement) wrap(m.target.parentElement); return; }
      m.addedNodes.forEach((x) => { if (x.nodeType === 1) wrap(x); else if (x.nodeType === 3 && x.parentElement) wrap(x.parentElement); });
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
